<template>
    <div>
        <div style="margin-top: 15px">
            <el-row :gutter="12">
                <el-col :span="8">
                    <el-button type="primary" style="margin-left: 3px;" icon="el-icon-top" @click="codes='',importVisible=true">导入</el-button>
                </el-col>
                <el-col :span="16">
                    <div style="text-align: right;">
                        <el-select style="width: 130px;" v-model="selectValue" placeholder="请选择">
                            <el-option value="1" label="滤芯编码"></el-option>
                            <el-option value="2" label="设备条形码"></el-option>
                        </el-select>
                        <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="getTableData">搜索</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable"
                      :data="tableData"
                      style="width: 100%"
                      element-loading-text="数据正在加载中"
                      :header-cell-style="headClass"
                      :row-style="rowClass">
                <!-- <el-table-column type="selection" width="60"></el-table-column> -->
                <el-table-column prop="code" label="滤芯编码"></el-table-column>
                <el-table-column label="入库时间" prop="posttime" :formatter="dateFormat"></el-table-column>
                <el-table-column label="是否使用">
                    <template slot-scope="scope">
                        {{scope.row.nid != 0 ? "是":"否"}}
                    </template>
                </el-table-column>
                <el-table-column label="绑定设备" prop="sn"></el-table-column>
                <el-table-column label="绑定时间" prop="bindtime" :formatter="dateFormat"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="del(scope.row.fid)">删除</button>
                        <button @click="unbind(scope.row.fid)">解绑</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="condition.pageId"
                           :page-sizes="[10, 50, 100, 200]"
                           :page-size="condition.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
            <el-dialog title="滤芯导入" :visible.sync="importVisible" width="600px" :modal-append-to-body="false" :close-on-click-modal="false">
                <el-input
                          type="textarea"
                          :rows="8"
                          placeholder="请输入待带入的滤芯编码，以英文逗号分割"
                          v-model="codes"
                          @input="inputHandler">
                </el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="importVisible = false">取消</el-button>
                    <el-button type="primary" @click="importFilter()">确定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import {
        request
    } from '@/utils/request';
    export default {
        name: "waterFilter.vue",
        data() {
            return {
                tableData: [],
                condition: {
                    pageId: 1,
                    size: 10
                },
                total: 0,
                selectValue: '',
                queryValue: '',
                importVisible: false,
                codes: ''
            }
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            inputHandler() {
                this.codes = this.codes.replaceAll(/，/g, ',');
            },
            handleSizeChange(val) {
                this.condition.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.condition.pageId = val;
                this.getTableData();
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            importFilter() {
                request({
                    url: '/waterFilter/add.do',
                    method: 'get',
                    params: {
                        codes: this.codes
                    }
                }).then(res => {
                    if (res.data == "") {
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error("导入失败：" + res.data);
                    }
                    this.importVisible = false;
                    this.getTableData();
                });

            },
            del(fid) {
                request({
                    url: '/waterFilter/delete.do',
                    method: 'get',
                    params: {
                        fid: fid
                    }
                }).then(res => {
                    if (res.data) {
                        this.$message.success('操作成功');
                        this.getTableData();
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            },
            unbind(fid) {
                request({
                    url: '/waterFilter/unbind.do',
                    method: 'get',
                    params: {
                        fid: fid
                    }
                }).then(res => {
                    if (res.data) {
                        this.$message.success('操作成功');
                        this.getTableData();
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            },
            getTableData() {
                let params = {
                    pageId: this.condition.pageId,
                    size: this.condition.size
                }
                if (this.selectValue != '') {
                    if (this.selectValue == '1') {
                        params.code = this.queryValue
                    } else if (this.selectValue == '2') {
                        params.sn = this.queryValue
                    }
                }
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/waterFilter/list.do', {
                    params: params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },

            dateFormat(row, column, cellValue, index) {
                var str = cellValue;
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                return year + "-" + month + "-" + day;
            },
        }
    }
</script>

<style scoped>
    .detail-image {
        width: 120px;
        height: 120px;
    }
</style>